module.exports = __webpack_public_path__ + "static/assets/a54d43f299ae8de119229ab205fcc44d.svg";